import { render, staticRenderFns } from "./CreateSupplierOrder.vue?vue&type=template&id=66ee3221&scoped=true&"
import script from "./CreateSupplierOrder.vue?vue&type=script&lang=js&"
export * from "./CreateSupplierOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateSupplierOrder.vue?vue&type=style&index=0&id=66ee3221&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee3221",
  null
  
)

export default component.exports